<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="C4342、C4352、CS730、CS735、CS737 プリンタ">
     C4342、C4352、CS730、CS735、CS737 プリンタ
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_ja" title="安全に関する情報">
     安全に関する情報
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="表記規則">
      表記規則
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e40" title="製品ステートメント">
      製品ステートメント
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_ja" title="プリンタについての確認">
     プリンタについての確認
    </a>
   </p>
   <div id="divd0e171">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_ja" title="プリンタに関する情報を見つける">
      プリンタに関する情報を見つける
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_ja" title="プリンタのシリアル番号を確認する">
      プリンタのシリアル番号を確認する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-models-topic.html#configured-models_ja" title="プリンタ構成">
      プリンタ構成
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_ja" title="操作パネルを使用する">
      操作パネルを使用する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_ja" title="インジケータランプの状態について理解する">
      インジケータランプの状態について理解する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e491" title="用紙を選択する">
      用紙を選択する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_ja" title="設定、設置、構成">
     設定、設置、構成
    </a>
   </p>
   <div id="divd0e1631">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_ja" title="プリンタの設置場所を選択する">
      プリンタの設置場所を選択する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_ja" title="ケーブルを接続する">
      ケーブルを接続する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e1809" title="ホーム画面のアプリケーションをセットアップして使用する">
      ホーム画面のアプリケーションをセットアップして使用する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-contacts-topic.html#managing-contacts_ja" title="連絡先を管理する">
      連絡先を管理する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e2273" title="アクセシビリティ機能をセットアップして使用する">
      アクセシビリティ機能をセットアップして使用する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-type-topic.html#d0e2496" title="用紙と特殊用紙をセットする">
      用紙と特殊用紙をセットする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e2719" title="ソフトウェア、ドライバ、ファームウェアのインストールと更新">
      ソフトウェア、ドライバ、ファームウェアのインストールと更新
     </a>
    </p>
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e2978" title="ハードウェアオプションを取り付ける">
      ハードウェアオプションを取り付ける
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e3406" title="ネットワーク">
      ネットワーク
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_ja" title="シリアル印刷を設定する（Windows のみ）">
      シリアル印刷を設定する（Windows のみ）
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_ja" title="プリンタを保護する">
     プリンタを保護する
    </a>
   </p>
   <div id="divd0e3794">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_ja" title="セキュリティスロットの場所">
      セキュリティスロットの場所
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_ja" title="プリンタメモリを消去する">
      プリンタメモリを消去する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_ja" title="プリンタストレージドライブを消去する">
      プリンタストレージドライブを消去する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ja" title="出荷時初期設定を復元する">
      出荷時初期設定を復元する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_ja" title="揮発性に関する記述">
      揮発性に関する記述
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_ja" title="印刷">
     印刷
    </a>
   </p>
   <div id="divd0e3986">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_ja" title="コンピュータから印刷する">
      コンピュータから印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e4012" title="モバイルデバイスから印刷する">
      モバイルデバイスから印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_ja" title="フラッシュメモリから印刷する">
      フラッシュメモリから印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_ja" title="サポートされているフラッシュメモリとファイルタイプ">
      サポートされているフラッシュメモリとファイルタイプ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_ja" title="コンフィデンシャルジョブを設定する">
      コンフィデンシャルジョブを設定する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_ja" title="コンフィデンシャルジョブおよびその他の保留ジョブを印刷する">
      コンフィデンシャルジョブおよびその他の保留ジョブを印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_ja" title="フォントサンプルリストを印刷する">
      フォントサンプルリストを印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_ja" title="ディレクトリリストを印刷する">
      ディレクトリリストを印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_ja" title="各コピー部数の間に挿入紙を入れる">
      各コピー部数の間に挿入紙を入れる
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_ja" title="印刷ジョブをキャンセルする">
      印刷ジョブをキャンセルする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_ja" title="トナーの濃さを調整する">
      トナーの濃さを調整する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="use-printer-menus-chapter.html#use-printer-menus-chapter_ja" title="プリンタメニューを使う">
     プリンタメニューを使う
    </a>
   </p>
   <div id="divd0e4610">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_ja" title="メニューマップ">
      メニューマップ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e4904" title="デバイス">
      デバイス
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e6697" title="印刷">
      印刷
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e7977" title="用紙">
      用紙
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e8271" title="USB ドライブ">
      USB ドライブ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e8508" title="ネットワーク/ポート">
      ネットワーク/ポート
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e10520" title="セキュリティ">
      セキュリティ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e11648" title="クラウドサービス">
      クラウドサービス
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e11705" title="レポート">
      レポート
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_ja" title="トラブルシューティング">
      トラブルシューティング
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_ja" title="メニュー設定ページを印刷する">
      メニュー設定ページを印刷する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_ja" title="プリンタのメンテナンス">
     プリンタのメンテナンス
    </a>
   </p>
   <div id="divd0e11935">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_ja" title="部品と消耗品の状況を確認する">
      部品と消耗品の状況を確認する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_ja" title="消耗品通知を設定する">
      消耗品通知を設定する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_ja" title="E メールアラートをセットアップする">
      E メールアラートをセットアップする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_ja" title="レポートを表示する">
      レポートを表示する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_ja" title="部品と消耗品を注文する">
      部品と消耗品を注文する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e12467" title="消耗品を交換する">
      消耗品を交換する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e12800" title="プリンタ部品の清掃">
      プリンタ部品の清掃
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e12920" title="電力と用紙を節約する">
      電力と用紙を節約する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_ja" title="プリンタを別の場所に移動する">
      プリンタを別の場所に移動する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_ja" title="プリンタを輸送する">
      プリンタを輸送する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_ja" title="問題のトラブルシューティング">
     問題のトラブルシューティング
    </a>
   </p>
   <div id="divd0e13073">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_ja" title="印刷品質の問題">
      印刷品質の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_ja" title="プリンタのエラーコード">
      プリンタのエラーコード
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e13835" title="印刷の問題">
      印刷の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_ja" title="プリンタが応答していない">
      プリンタが応答していない
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_ja" title="フラッシュメモリを読み取れない">
      フラッシュメモリを読み取れない
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_ja" title="USB ポートを有効にする">
      USB ポートを有効にする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams-group.html#d0e16390" title="紙詰まりを取り除く">
      紙詰まりを取り除く
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e16671" title="ネットワーク接続の問題">
      ネットワーク接続の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e16899" title="ハードウェアオプションの問題">
      ハードウェアオプションの問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e17153" title="消耗品の問題">
      消耗品の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e17281" title="給紙の問題">
      給紙の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e17647" title="色品質の問題">
      色品質の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ja" title="カスタマサポートに問い合わせる">
      カスタマサポートに問い合わせる
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_ja" title="リサイクルおよび廃棄">
     リサイクルおよび廃棄
    </a>
   </p>
   <div id="divd0e17898">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_ja" title="Lexmark 製品のリサイクルプログラム">
      Lexmark 製品のリサイクルプログラム
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_ja" title="Lexmark 製品の梱包材をリサイクルする">
      Lexmark 製品の梱包材をリサイクルする
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_ja" title="通知">
     通知
    </a>
   </p>
   <div id="divd0e17933">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e17936" title="製品情報">
      製品情報
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e17953" title="版通知">
      版通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_ja" title="商標">
      商標
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_ja" title="ライセンスに関する通知">
      ライセンスに関する通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_ja" title="騒音レベル">
      騒音レベル
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_ja" title="製品の廃棄">
      製品の廃棄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_ja" title="静電気感知に関する通知">
      静電気感知に関する通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_ja" title="国際エネルギースタープログラム（ENERGY STAR）">
      国際エネルギースタープログラム（ENERGY STAR）
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_ja" title="温度に関する情報">
      温度に関する情報
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_ja" title="レーザーについて">
      レーザーについて
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_ja" title="電力消費量">
      電力消費量
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#japanese-vcci-notice_ja" title="日本の VCCI 規定">
      日本の VCCI 規定
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_ja" title="電波障害について">
      電波障害について
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue